import moment from "moment"
import { colors, getStaOperatorHamaliLabel, isStaCompany } from "../../../common/helper";
import { xlCol, xlColq } from "../../../common/constants";

export const goodBalanceReportViewData = [
    { view: 'Detailed', id: 0 },
    { view: 'Summary', id: 1 },
]
export const reportOption = [
    { Option: 'Booking Goods Balance', optionId: 1 },
    { Option: 'Delivery Goods Balance', optionId: 0 },
]
export const GoodBalReprtPayType = [
    { typeId: 0, name: "All", uniqKey: "All" },
    { typeId: 1, name: "Paid", uniqKey: "PAID" },
    { typeId: 2, name: "To Pay", uniqKey: "TOPAY" },
    { typeId: 3, name: "FOC", uniqKey: "FOC" },
    { typeId: 4, name: "COD", uniqKey: "COD" },
    { typeId: 5, name: "On Account", uniqKey: "OnAcc" },
    { typeId: 6, name: "Paid (Manual)", uniqKey: "PAID" },
    { typeId: 7, name: "To Pay (Manual)", uniqKey: "TOPAY" },
    { typeId: 8, name: "Self", uniqKey: "Self" },
    { typeId: 9, name: "To Pay DDDV", uniqKey: "ToPayDDDV" },
    { typeId: 10, name: "On Account (Manual)", uniqKey: "OnAcc" }
];

export const TicketFormatStructure = {
    FormatID: 1,
    CompanyID: 0,
    IsLogo: 0,
    LogoUrl: '',
    IsHelpline: 0,
    Helpline: '',
    IsWebsite: 0,
    Website: '',
    IsRulesAndRegulations: 1,
    RulesAndRegulations: '',
    IsDeclarationBooking: 0,
    DeclarationBooking: '',
    IsDeclarationDelivery: 0,
    DeclarationDelivery: '',
}

export const pdfHeaderColumn = [
    { headerName: 'Selected City', exportHead: 'Selected City', field: 'selSelectedCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Selected Branch', exportHead: 'Selected Branch', field: 'selSelectedBranch', xlCol: { dataType: 'string', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: { dataType: 'string', dataFormatter: null },span:3, align: "right" },
    { headerName: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Report Type', exportHead: 'Report Type', field: 'reportOptions', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "right" },
    { headerName: 'Destination City', exportHead: 'Destination City', field: 'destCity', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
    { headerName: 'Destination Branch', exportHead: 'Destination Branch', field: 'destBr', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
]
export const FilterHeader = [
    // { headerName: 'Company Name',header: 'Company Name', exportHead: 'Company Name', field: 'company', xlCol: xlCol,span:3, align: "left" },
    { headerName: 'From Date',header: 'From Date', exportHead: 'From Date', field: 'fromDate', xlCol: xlCol,span:3, align: "left" },
    { headerName: 'To Date',header: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: xlCol,span:3, align: "left" },
    { headerName: 'Selected City',header: 'Selected City', exportHead: 'Selected City', field: 'selSelectedCity', xlCol: xlCol,span:2, align: "left" },
    { headerName: 'Selected Branch',header: 'Selected Branch', exportHead: 'Selected Branch', field: 'selSelectedBranch', xlCol: xlCol,span:2, align: "left" },
    { headerName: 'Payment Type',header: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: xlCol,span:2, align: "left" },
    { headerName: 'Report View',header: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: xlCol,span:3, align: "left" },
    { headerName: 'Report Type',header: 'Report Type', exportHead: 'Report Type', field: 'reportOptions', xlCol: xlCol,span:3, align: "left" },
]
// export const pdfHeaderColumnV2 = [
//     { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PayType', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
//     { headerName: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
//     { headerName: 'Report Type', exportHead: 'Report Type', field: 'reportType', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
//     { headerName: '', exportHead: '', field: 'destBr', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
// ]
// export const headerDatav2 = [{ srcCity: "Bangalore", srcBr: "Maven Ops Ahmedabad", destCity: "All", destBr: "All" }]
// export const headerDatav3 = [{ PayType: "All", reportView: "Detailed", reportType: "Booking Goods Balance", destBr: "" }]
export const PDFHeaderColumns = (intCompanyID) => [
    { headerName: 'S/N',header: 'S/N', exportHead: 'S/N', field: 'SN', xlCol: xlCol, weight:10, align: "left" },
    { headerName: 'LR No.\nBkg. Date ',header: 'LR No.\nBkg. Date ', exportHead: 'LR No.\nBkg. Date ', field: 'LRNO^^BookingDate', xlCol: xlCol, isSortIcon: true, weight:50, align: "left" },
    // { headerName: 'Formatted\n LR No.', exportHead: 'Formatted\n LR No.', field: 'ManualLRNO', xlCol: { dataType: 'string', dataFormatter: null }, isSortIcon: true, weight:30, align: "left" },
    { headerName: 'Manual\nLR No.',header: 'Manual\nLR No.', exportHead: 'Manual\nLR No.', field: 'ManualLRNO', xlCol: xlCol, isSortIcon: true, weight:30, align: "left" },
    { headerName: 'Src. City\nSrc. Br.',header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SourceCity^^SourceBranch', xlCol: xlCol, isSortIcon: true, weight:50, align: "left" },
    { headerName: 'Dest. City\nDest. Br.',header: 'Dest. City\nDest. Br.', exportHead: 'Dest. City\nDest. Br.', field: 'DestinationCity^^DestinationBranch', xlCol: xlCol, isSortIcon: true, weight:50, align: "left" },
    { headerName: 'Sndr. Name\nRec. Name',header: 'Sndr. Name\nRec. Name', exportHead: 'Sndr. Name\nRec. Name', field: 'Sender^^RecName', xlCol: xlCol, isSortIcon: true, weight:50, align: "left" },
    { headerName: 'Pymt.\nType',header: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', xlCol: xlCol, isSortIcon: true, weight:40, align: "left" },
    { headerName: 'Item\nUnits',header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Items', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    { headerName: 'Frt.\nChrg.',header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    { headerName: 'Cart.\nChrg.',header: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'Cartage', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    { headerName: 'Ham.\nChrg.',header: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'Hamali', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    { headerName: 'Val.\nChrg.',header: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    isStaCompany(intCompanyID) && {
        headerName: getStaOperatorHamaliLabel(true),
        header: getStaOperatorHamaliLabel(true),
        exportHead: getStaOperatorHamaliLabel(false),
        field: 'OperatorHamaliChg',
        xlCol: xlColq,
        isSortIcon: true,
        weight: 30,
        align: "right",
    },
    { headerName: 'Oth.\nChrg.', header: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    { headerName: 'Bkg.\nGST',header: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
    { headerName: 'Net.\nAmt.',header: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', xlCol: xlColq, isSortIcon: true, weight:30, align: "right" },
].filter(Boolean)

export const PDFHeaderColumnsForEx = (intCompanyID) => [
    { headerName: 'S/N', exportHead: 'S/N', field: 'SN', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
    { headerName: 'LR No.', exportHead: 'LR No.\nBkg. Date ', field: 'LRNODate', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Manual\nLR No.', exportHead: 'Manual\nLR No.', field: 'ManualLRNO', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Bkg. Date ', exportHead: 'LR No.\nBkg. Date ', field: 'LRNODate', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Src. City', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCityBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Src. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCityBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Dest. City', exportHead: 'Dest. City\nDest. Br.', field: 'DestCityBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Dest. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCityBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Sndr. Name', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCityBranch', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Rec. Name', exportHead: 'Sndr. Name\nRec. Name', field: 'SenRecName', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
    { headerName: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Items', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'Freight', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Cart.\nChrg.', exportHead: 'Cart.\nChrg.', field: 'Cartage', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Ham.\nChrg.', exportHead: 'Ham.\nChrg.', field: 'Hamali', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Val.\nChrg.', exportHead: 'Val.\nChrg.', field: 'Valuation', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    isStaCompany(intCompanyID) && {
        headerName: getStaOperatorHamaliLabel(true),
        exportHead: getStaOperatorHamaliLabel(false),
        field: 'OperatorHamaliChg',
        xlCol: { dataType: 'number', dataFormatter: null, halign: "right" },
        align: "right",
    },
    { headerName: 'Oth.\nChrg.', exportHead: 'Oth.\nChrg.', field: 'OtherCharges', xlCol: { dataType: 'number', dataFormatter: null, halign: "right" }, align: "right" },
    { headerName: 'Bkg.\nGST', exportHead: 'Bkg.\nGST', field: 'BookingGST', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
    { headerName: 'Net.\nAmt.', exportHead: 'Net.\nAmt.', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null }, align: "right" },
].filter(Boolean)

export const detailColumnsStyles = {
    0: { halign: 'right', cellWidth: 35, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left', cellWidth: 80, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'left', cellWidth: 60, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'left', cellWidth: 125, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'left', cellWidth: 130, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'left', cellWidth: 150, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'left', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    11: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    12: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    13: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    14: { halign: 'right', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    15: { halign: 'right', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
export const detailColumnsStyles1 = {
    0: { halign: 'right', cellWidth: 35, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left', cellWidth: 70, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'left', cellWidth: 70, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'left', cellWidth: 60, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'left', cellWidth: 115, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'left', cellWidth: 110, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'left', cellWidth: 120, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'left', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    11: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    12: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    13: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    14: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    15: { halign: 'right', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    16: { halign: 'right', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}

export const detailFormateData = (array, headerData, companyID) => {
    const data = []
    
    // const sortedArray = companyID === 804
    //     ? [...array].sort((a, b) => {
    //         const sourceCityComparison = a.SourceCity.localeCompare(b.SourceCity);
    //         if (sourceCityComparison !== 0) return sourceCityComparison;
    //         return a.DestinationCity.localeCompare(b.DestinationCity);
    //     })
    //     : array.sort((a, b) => (moment(a.BookingDate, 'DD-MMM-YY').valueOf() - moment(b.BookingDate, 'DD-MMM-YY').valueOf()));

        array.forEach((item, i) => {
        data.push({
            ...item,
            SN: i + 1,
            LRNODate: `${item.LRNO}\n${item.BookingDate}`,
            SrcCityBranch: `${item.SourceCity}\n${item.SourceBranch||""}`,
            DestCityBranch: `${item.DestinationCity}\n${item.DestinationBranch ||""}`,
            SenRecName: `${item.Sender}\n${item.RecName}`,
        })
    })
    let TotalItems = 0
    let TotalFreight = 0
    let TotalCartageAmt = 0
    let TotalHamaliChgs = 0
    let TotalOtherChgs = 0
    let TotalBookingGST = 0
    let TotalValuation = 0
    let TotalNetAmount = 0

    TotalItems = data?.map((item) => item?.Items).reduce((partialSum, a) => partialSum + a, 0)
    TotalFreight = data?.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
    TotalCartageAmt = data?.map((item) => item?.Cartage).reduce((partialSum, a) => partialSum + a, 0)
    TotalHamaliChgs = data?.map((item) => item?.Hamali).reduce((partialSum, a) => partialSum + a, 0)
    TotalValuation = data?.map((item) => item?.Valuation).reduce((partialSum, a) => partialSum + a, 0)
    TotalOtherChgs = data?.map((item) => item?.OtherCharges).reduce((partialSum, a) => partialSum + a, 0)
    TotalBookingGST = data?.map((item) => item?.BookingGST).reduce((partialSum, a) => partialSum + a, 0)
    TotalNetAmount = data?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)

    const TotalOperatorHamaliChg = data?.map((item) => item?.OperatorHamaliChg || 0).reduce((partialSum, a) => partialSum + a, 0)

    const totalRow = {
        SN: `Total: ${headerData?.reportOptions}`,
        Items: TotalItems,
        Freight: TotalFreight,
        Cartage: TotalCartageAmt,
        Hamali: TotalHamaliChgs,
        Valuation: TotalValuation.toFixed(2),
        OtherCharges: TotalOtherChgs.toFixed(2),
        BookingGST: TotalBookingGST,
        NetAmount: TotalNetAmount.toFixed(2),
        isTotal: true,
    }
    if (isStaCompany(companyID)) {
        totalRow.OperatorHamaliChg = TotalOperatorHamaliChg.toFixed(2)
    }
    data.push(totalRow)
    return data
}

export const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
}
export const DetailsDrawCell=(data,flag)=>{
    var rows = data.table.body
    rows.map((val) => {
        // colors[item.PaymentTypeID - 1]
        val.cells[flag==2?7:6].styles.fillColor=colors[val.raw.PaymentTypeID-1]
        if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right"
            } else {
                data.cell.styles.halign = "left"
            }
        }
        if (flag == 2) {
            if (val.raw.isTotal) {
                val.cells[0].colSpan = 8
                val.cells[0].styles.font = 'Roboto'
                val.cells[0].styles.fontStyle = 'normal'
                val.cells[0].styles.fontS0ze = '16'
                val.cells[0].styles.textColor = [0, 0, 0]
                val.cells[0].styles.halign = 'right'
                val.cells[0].styles.fillColor = [238, 238, 238]
                for (let i = 8; i <= 15; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [238, 238, 238]
                }
            }
        } else {
            if (val.raw.isTotal) {
                val.cells[0].colSpan = 7
                val.cells[0].styles.font = 'Roboto'
                val.cells[0].styles.fontStyle = 'normal'
                val.cells[0].styles.fontS0ze = '16'
                val.cells[0].styles.textColor = [0, 0, 0]
                val.cells[0].styles.halign = 'right'
                val.cells[0].styles.fillColor = [238, 238, 238]
                for (let i = 7; i <= 14; i++) {
                    val.cells[i].colSpan = 1
                    val.cells[i].styles.font = 'Roboto'
                    val.cells[i].styles.fontStyle = 'normal'
                    val.cells[i].styles.fontSize = '16'
                    val.cells[i].styles.textColor = [0, 0, 0]
                    val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                    val.cells[i].styles.fillColor = [238, 238, 238]
                }
            }
        }
    })
}
export const shortFilterData=[
        {id:1,name:'Booking Date'},
        {id:2,name:'LR No'},
        {id:3,name:'Source City'},
        {id:4,name:'Destination City'},
        {id:5,name:'Payment Type'},
    ]

export const summaryHeader = [
    { header: 'S/N', exportHead: 'S/N', field: 'SN', xlCol: xlColq, weight: 5},
    { header: 'Destination\nCity', exportHead: 'Destination\nCity', field: 'DestinationCity', xlCol: xlCol, isSortIcon: true, weight: 30},
    { header: 'Paid\nUnit', exportHead: 'Paid\nUnit', field: 'PaidUnit', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'Paid\nAmount', exportHead: 'Paid\nAmount', field: 'PaidAmount', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'ToPay\nUnit', exportHead: 'ToPay\nUnit', field: 'ToPayUnit', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'ToPay\nAmount', exportHead: 'ToPay\nAmount', field: 'ToPayAmount', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'OnAccount\nUnit', exportHead: 'OnAccount\nUnit', field: 'OnAccountUnit', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'OnAccount\nAmount', exportHead: 'OnAccount\nAmount', field: 'OnAccountAmount', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'Total\nUnit', exportHead: 'Total\nUnit', field: 'TotalUnit', xlCol: xlColq, isSortIcon: true, weight: 30},
    { header: 'Total\nAmount', exportHead: 'Total\nAmount', field: 'TotalAmount', xlCol: xlColq,isSortIcon: true, weight: 30}
]    

export const filterHeader = [
    { header: 'Company Name', exportHead: 'Company Name', field: 'company', xlCol: xlCol },
    { header: 'From Date', exportHead: 'From Date', field: 'fromDate', xlCol: xlCol },
    { header: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: xlCol },
    { header: 'Selected City', exportHead: 'Selected City', field: 'selSelectedCity', xlCol: xlCol },
    { header: 'Selected Branch', exportHead: 'Selected Branch', field: 'selSelectedBranch', xlCol: xlCol },
    { header: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: xlCol},
    { header: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: xlCol },
    { header: 'Report Type', exportHead: 'Report Type', field: 'reportOptions', xlCol: xlCol },
]